// enums/ActionTypes.js
export const ActionTypes = Object.freeze({
    PRINT: 'Print',
    VIEW: 'View'
  });
  